import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-pratibha',
  templateUrl: './pratibha.component.html',
  styleUrls: ['./pratibha.component.scss']
})
export class PratibhaComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getPratibha();
  }

}
